import { render, staticRenderFns } from "./simpleMenu.vue?vue&type=template&id=f4453a7a"
import script from "./simpleMenu.vue?vue&type=script&lang=js"
export * from "./simpleMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutsHeaderComponent: require('/usr/src/app/components/layouts/HeaderComponent.vue').default,ModalsConnectionModalWindows: require('/usr/src/app/components/modals/ConnectionModalWindows.vue').default})
